import React, { useState } from "react";
import { Download, Share, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useInstallPrompt } from "@/lib/pwa";

const KEY = "mv_install_dismissed";

/** Bottom banner that offers to add the app to the phone's home screen. */
export const InstallPrompt = () => {
  const { canInstall, install, installed, ios } = useInstallPrompt();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");

  const show = !installed && !hidden && (canInstall || ios);
  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setHidden(true);
  };

  return (
    <div className="fixed inset-x-3 bottom-3 z-50 animate-fade-up sm:left-auto sm:right-4 sm:w-[360px]"
      data-testid="install-banner">
      <div className="flex items-start gap-3 rounded-2xl border border-border bg-card p-3 shadow-lg">
        <img src="/icon-192.png" alt="" className="h-11 w-11 shrink-0 rounded-xl" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">Install Megatronix Vision</p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {ios && !canInstall
              ? "Tap Share, then \u201cAdd to Home Screen\u201d to use it like an app."
              : "Add it to your home screen and it opens full screen, like a normal app."}
          </p>
          {canInstall && (
            <Button size="sm" className="mt-2.5 w-full" data-testid="install-app-btn"
              onClick={async () => { const r = await install(); if (r !== "accepted") dismiss(); }}>
              <Download className="h-3.5 w-3.5" /> Install app
            </Button>
          )}
          {ios && !canInstall && (
            <p className="mt-2 flex items-center gap-1.5 text-xs font-medium text-primary">
              <Share className="h-3.5 w-3.5" /> Share &rarr; Add to Home Screen
            </p>
          )}
        </div>
        <button onClick={dismiss} data-testid="install-dismiss"
          className="shrink-0 rounded-md p-1 text-muted-foreground transition-colors hover:text-foreground">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
